import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {DashboardComponent} from "./modules/dashboard/dashboard.component";
import {AngularFireAuthGuard, redirectUnauthorizedTo} from "@angular/fire/auth-guard";
import {ParticipantsComponent} from "./modules/participants/participants.component";
import {RankingComponent} from "./modules/ranking/ranking.component";
import {TournamentsListComponent} from "./modules/tournaments/tournaments-list/tournaments-list.component";
import {RulesComponent} from "./modules/rules/rules.component";
import {MainPageComponent} from "./modules/main-page/main-page.component";
import { ContactsComponent } from './modules/contacts/contacts.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['auth']);

const routes: Routes = [
  {
    path: '',
    redirectTo: 'courts',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'courts',
    loadChildren: () => import('./modules/courts-booking/courts-booking.module').then(m => m.CourtsBookingModule),
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  {
    path: 'participants',
    component: ParticipantsComponent,
    canActivate: [
      AngularFireAuthGuard
    ],
    data: { authGuardPipe: redirectUnauthorizedToLogin }
  },
  {
    path: 'ranking',
    component: RankingComponent,
  },
  {
    path: 'rules',
    component: RulesComponent
  },
  {
    path: 'about',
    component: ContactsComponent,
  },
  {
    path: 'tournaments',
    loadChildren: () => import('./modules/tournaments/tournaments.module').then(m => m.TournamentsModule),
  },
  {
    path: 'courses',
    loadChildren: () => import('./modules/courses/courses.module').then((m => m.CoursesModule)),
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin-users/admin-users.module').then(m => m.AdminUsersModule),
  },
  {
    path: 'championships',
    loadChildren: () => import('./modules/championships/championships.module').then(m => m.ChampionshipsModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
